import styled from "styled-components";

export const RelativeReportLoadingReport = styled.div`
  ${(props) => `
      align-items: center;
      background-color: #FFF;
      border-radius: 50%;
      display: flex;
      font-family: ${props.theme.fontFamilies.primaryFont};
      height: 11rem;
      justify-content: center;
      width: 11rem;
  `}
  .img-processing-report {
    height: 9rem;
    width: 9rem;
  }
`;

export const ColumnReportGenerate = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const LabelGenerateReport = styled.div`
  text-align: center;
  font-size: 2rem;
  color: #ffffff;
  text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.45);
  margin-top: 1.6rem;
  font-weight: 800;
`;
export const LabelDownload = styled.div`
  text-align: center;
  font-size: 1.5rem;
  color: #ffffff;
  text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.45);
  font-weight: 600;
  margin-top: 0.5rem;
`;
